export default __webpack_public_path__ + "static/media/apvs-material-4.b8a86668.webp";